import { IRbac } from '../../apis/__shared/rbac.interfaces';

export const mockRbacAdminStaff: IRbac = {
  dashboard: {
    finance: {
      read: true,
      write: false,
      delete: false,
    },
    people: {
      read: true,
      write: true,
      delete: false,
    },
    events: {
      read: true,
      write: true,
      delete: true,
    },
  },
  students: {
    studentList: {
      read: true,
      write: true,
      delete: false,
    },
    attendance: {
      read: true,
      write: true,
      delete: false,
    },
    fees: {
      read: true,
      write: false,
      delete: false,
    },
    events: {
      read: true,
      write: true,
      delete: true,
    },
    scores: {
      read: true,
      write: false,
      delete: false,
    },
    documents: {
      read: true,
      write: true,
      delete: true,
    },
  },
  staff: {
    staffList: {
      read: true,
      write: true,
      delete: false,
    },
    attendance: {
      read: true,
      write: true,
      delete: false,
    },
    payouts: {
      read: true,
      write: false,
      delete: false,
    },
    events: {
      read: true,
      write: true,
      delete: true,
    },
    documents: {
      read: true,
      write: true,
      delete: true,
    },
  },
  academics: {
    curriculum: {
      read: true,
      write: false,
      delete: false,
    },
    schedules: {
      read: true,
      write: true,
      delete: false,
    },
    lessonPlans: {
      read: true,
      write: false,
      delete: false,
    },
    materials: {
      read: true,
      write: false,
      delete: false,
    },
    assessments: {
      read: true,
      write: false,
      delete: false,
    },
    library: {
      read: true,
      write: false,
      delete: false,
    },
  },
  communications: {
    messaging: {
      read: true,
      write: true,
      delete: true,
    },
    announcements: {
      read: true,
      write: true,
      delete: true,
    },
    concerns: {
      read: true,
      write: true,
      delete: false,
    },
    events: {
      read: true,
      write: true,
      delete: true,
    },
    meetings: {
      read: true,
      write: true,
      delete: true,
    },
  },
  finance: {
    financeList: {
      read: true,
      write: false,
      delete: false,
    },
    scholarships: {
      read: true,
      write: false,
      delete: false,
    },
    financialReports: {
      read: true,
      write: false,
      delete: false,
    },
  },
  analytics: {
    performance: {
      read: true,
      write: false,
      delete: false,
    },
    customDashboards: {
      read: false,
      write: false,
      delete: false,
    },
  },
  administration: {
    transport: {
      read: true,
      write: true,
      delete: true,
    },
    inventory: {
      read: true,
      write: true,
      delete: true,
    },
    healthAndSafety: {
      read: true,
      write: true,
      delete: false,
    },
  },
  users: {
    parents: {
      read: true,
      write: true,
      delete: false,
    },
    visitors: {
      read: true,
      write: true,
      delete: true,
    },
    guests: {
      read: true,
      write: true,
      delete: true,
    },
    internalUsers: {
      read: true,
      write: true,
      delete: true,
    },
  },
  settings: {
    userManagement: {
      read: true,
      write: true,
      delete: false,
    },
    complianceManagement: {
      read: true,
      write: true,
      delete: false,
    },
  },
  profile: {
    personalDetails: {
      read: true,
      write: true,
      delete: false,
    },
    documents: {
      read: true,
      write: true,
      delete: true,
    },
    calendar: {
      read: true,
      write: true,
      delete: true,
    },
    leaves: {
      read: true,
      write: true,
      delete: false,
    },
  },
  guardian: {
    dashboard: { read: false, write: false, delete: false },
    academicsSchedule: { read: false, write: false, delete: false },
    academicsCurriculum: { read: false, write: false, delete: false },
    academicsLessonPlans: { read: false, write: false, delete: false },
    academicsMaterials: { read: false, write: false, delete: false },
    academicsAssessments: { read: false, write: false, delete: false },
    academicsHomework: { read: false, write: false, delete: false },
    academicsAttendance: { read: false, write: false, delete: false },
    academicsLibrary: { read: false, write: false, delete: false },
    fees: { read: false, write: false, delete: false },
    transport: { read: false, write: false, delete: false },
    documents: { read: false, write: false, delete: false },
    eventsCommunication: { read: false, write: false, delete: false },
    concerns: { read: false, write: false, delete: false },
    profile: { read: false, write: false, delete: false },
    settings: { read: false, write: false, delete: false },
  },
};
